import type { DrillLocation, ExplorationSecondary, ExplorationVolume, ViewMode } from '../../types/exploration';
import { resolveDrillScope } from '../drill/resolveDrillScope';

export interface VolumesInCurrentScopeOptions {
  secondary: ExplorationSecondary;
  location: DrillLocation;
  groupByAccount: boolean;
  tagKey: string;
  view?: ViewMode;
}

/** Volumes visible in the currently drilled canvas scope. */
export function volumesInCurrentScope(
  volumes: ExplorationVolume[],
  opts: VolumesInCurrentScopeOptions
): ExplorationVolume[] {
  return resolveDrillScope(volumes, opts).volumes;
}
